import { render, staticRenderFns } from "./BannerRenewCertificateSispass.vue?vue&type=template&id=52714796&scoped=true"
import script from "./BannerRenewCertificateSispass.vue?vue&type=script&lang=js"
export * from "./BannerRenewCertificateSispass.vue?vue&type=script&lang=js"
import style0 from "./BannerRenewCertificateSispass.vue?vue&type=style&index=0&id=52714796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52714796",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
